import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './LeftNav.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function LeftNav(props) {
  const { formKey = 'MAIN_LEFT_NAV', formJson: _formJson = {}, fetchingForms: _fetchingForms = {} } = props;
  const formJson = _formJson[formKey] || {};
  const [isNavOpen, setIsNavOpen] = useState(false);

  useEffect(() => {
    props.getForms(formKey);
  }, [formKey]);

  const getUnOrderedList = (formJson) => {
    const { data = {} } = formJson;
    const { section = [] } = data;
    const [firstSection = {}] = section;
    const { fields = [] } = firstSection;
    return fields.map((field) => {
      const { id = '', name = '', link = '', type = '' } = field;
      return (
        <li key={id} className="nav-item">
          <Link className="nav-link text-light" to={link} onClick={() => setIsNavOpen(false)}>
            {name}
          </Link>
        </li>
      );
    });
  };

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  return (
    <>
      {/* Toggle Button for Mobile */}
      <button
        className="btn left-nav-toggle-btn d-md-none"
        onClick={toggleNav}
        aria-label={isNavOpen ? 'Close menu' : 'Open menu'}
      >
        {isNavOpen ? 'Close' : 'Menu'}
      </button>

      {isNavOpen && <div className="left-nav-backdrop d-md-none" onClick={toggleNav} />}

      {/* Navigation Panel */}
      <nav
        className={`left-nav ${isNavOpen ? 'left-nav-open' : ''}`}
      >
        <ul className="nav flex-column">
          {getUnOrderedList(formJson)}
        </ul>
      </nav>
    </>
  );
}

export default LeftNav;
